import { Component, Input } from '@angular/core';
import { BookingStatus } from '../../models/booking-status';
import { NgSwitch, NgSwitchCase, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'booking-status',
    template: `
    <div [ngSwitch]="status" data-cy="status-heading-container">
      <ng-container *ngSwitchCase="availableStatuses.REQUEST">
        <span
          class="inline-block border border-orange rounded py-1 px-3 text-orange-dark bg-orange-lightest text-lg"
        >
          {{ status | titlecase }}</span
        >
      </ng-container>
      <ng-container *ngSwitchCase="availableStatuses.QUOTATION">
        <span
          class="inline-block border border-teal rounded py-1 px-3 text-teal-darkest bg-teal-lightest  text-lg"
        >
          Pending Customer Response</span
        >
      </ng-container>
      <ng-container *ngSwitchCase="availableStatuses.CUSTOMER_ACCEPTED">
        <span
          class="inline-block border border-green rounded py-1 px-3 text-green-darkest bg-green-lightest text-lg"
        >
          {{ status | titlecase }}</span
        >
      </ng-container>
      <ng-container *ngSwitchCase="availableStatuses.COMPLETED">
        <span
          class="inline-block border border-blue rounded py-1 px-3 text-blue-darkest bg-blue-lightest text-lg"
        >
          {{ status | titlecase }}</span
        >
      </ng-container>
      <ng-container *ngSwitchCase="availableStatuses.CANCELLED">
        <span
          class="inline-block border border-gray rounded py-1 px-3 text-gray-darkest bg-gray-lightest text-lg"
        >
          {{ status | titlecase }}</span
        >
      </ng-container>
    </div>
  `,
    providers: [],
    standalone: true,
    imports: [NgSwitch, NgSwitchCase, TitleCasePipe]
})
export class BookingStatusComponent {
  @Input() status: BookingStatus;
  availableStatuses = BookingStatus;
}
